import React from 'react';

export default function PaymentPending() {
  const params = new URLSearchParams(window.location.search);
  const hasPayment = !!(params.get('razorpay_payment_id') || params.get('razorpay_subscription_id'));

  return (
    <div style={s.page}>
      <div style={s.card}>
        {hasPayment ? (
          <>
            <div style={s.iconWrap}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 18L15 26L29 10" stroke="#2ABFAB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 style={s.heading}>Payment Received</h2>
            <p style={s.body}>Your subscription is being activated. Tap the button below to return to the app.</p>
            <button style={s.btn} onClick={() => { window.location.href = 'lifechiai://payment-complete'; }}>
              Tap here to return to LifeChiAI
            </button>
            <p style={s.fallback}>If the app does not open, please launch it manually — your subscription will be active within a few minutes.</p>
          </>
        ) : (
          <p style={s.body}>If you completed payment, please return to the LifeChiAI app.</p>
        )}
      </div>
    </div>
  );
}

const s = {
  page:     { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F0F8FF', padding: '24px' },
  card:     { backgroundColor: '#fff', borderRadius: '16px', padding: '40px 32px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  iconWrap: { width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#E6F9F5', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  heading:  { fontSize: '22px', fontWeight: '700', color: '#0D1F1A', marginBottom: '12px' },
  body:     { fontSize: '15px', color: '#4A6B63', lineHeight: '1.6', marginBottom: '24px' },
  btn:      { display: 'inline-block', padding: '14px 32px', borderRadius: '10px', backgroundColor: '#2ABFAB', color: '#fff', fontSize: '15px', fontWeight: '600', border: 'none', cursor: 'pointer', minHeight: '44px', marginBottom: '16px' },
  fallback: { fontSize: '13px', color: '#8A9E98', lineHeight: '1.5' },
};
